import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { ReactComponent as LoginImg } from '../../../images/login-right.svg'
import video from '../../../images/contact/inner.mp4'

const useStyle = makeStyles((theme: Theme) => ({
  container: {
    marginTop: 176,
  },
  animationBack: {
    position: 'fixed',
    top: 0,
    right: 0,
    width: '50%',
    minHeight: '100%',
    background: '#584de2',
  },
  animation: {
    position: 'fixed',
    zIndex: 0,
    top: '50%',
    right: '50%',
    transform: 'translate(100%, -50%)',
    width: '50%',
    height: '100%',
    opacity: '50%',
    objectFit: 'cover',
  },
  animationAbove: {
    position: 'fixed',
    minHeight: '100%',
    background: '#0B0097',
    opacity: '60%',
  },
  section: {
    position: 'relative',
    zIndex: 1,
    paddingTop: 129,
    borderTop: '1px solid rgba(255,255,255,0.32)',
  },
  content: {
    maxWidth: 496,
    position: 'absolute',
    right: 0,
  },
  svg: {
    marginRight: theme.spacing(4),
  },
}))

export const RightPanel: FC = () => {
  const classes = useStyle()
  return (
    <Grid className={classes.container}>
      <Grid container className={classes.animationBack}>
        <video id="background-video" loop autoPlay muted className={classes.animation}>
          <source src={video} type="video/mp4" />
          <source src={video} type="video/ogg" />
          Your browser does not support the video tag.
        </video>

        <Grid container className={classes.animationAbove} />
      </Grid>

      <Grid container className={classes.section}>
        <Grid className={classes.content}>
          <LoginImg className={classes.svg} />
        </Grid>
      </Grid>
    </Grid>
  )
}
